const tabsResources = {
  en: {
    translation: {
      'Tab CCLI': 'Enter phone number and IIN of the owner',
      'Tab CCLI Input 1': 'State number',
      'Tab CCLI Input 1 Placeholder': 'A000AAA or 000AAA00',
      'Tab CCLI Input 2': 'IIN',
      'Tab Property': 'Choose object type and insurance period',
      'Tab Property Input 1': 'Choose object type',
      'Tab Property House': 'House',
      'Tab Property Flat': 'Apartment',
      'Tab Property Input 2': 'Insurance period',
      'Tab 6 Months': '6 months',
      'Tab 7 Months': '7 months',
      'Tab 8 Months': '8 months',
      'Tab 9 Months': '9 months',
      'Tab 10 Months': '10 months',
      'Tab 11 Months': '11 months',
      'Tab 12 Months': '12 months',
      'Tab Health': 'Choose location and insurance period',
      'Tab Health Input 1': 'Location',
      'Tab RK': 'RK',
      'Tab CIS': 'CIS',
      'Tab World': 'WORLD',
      'Tab Travel': 'Select the insurance period and the country of entry',
      'Tab Travel Country': 'Country of departure',
      'Tab Travel Choose': 'Choose a country',
      'Tab Travel All': 'All world',
      'Tab Travel Schengen': 'Schengen',
      'Tab Program': 'Program',
      'Tab Program Standard': 'Standard',
      'Tab Program Premium': 'Premium',
      'Tab Program Education': 'Education',
      'Tab Program Sport': 'Sports',
      'Tab Program Multi-Trip': 'Multi-Trip',
      'Tab CASCO': 'Choose a program',
      'Tab CASCO Sum': 'Sum insured',
      'Tab description': 'Data will be filled in automatically',
      'Tab button': 'Calculate',
    },
  },
  kz: {
    translation: {
      'Tab CCLI': 'Телефон нөмірін және иесінің ЖСН-ін енгізіңіз',
      'Tab CCLI Input 1': 'Мемлекеттік номер',
      'Tab CCLI Input 1 Placeholder': 'A000AAA / 000AAA00',
      'Tab CCLI Input 2': 'ЖСН',
      'Tab Property': 'Объектінің түрі мен сақтандыру мерзімін таңдаңыз',
      'Tab Property Input 1': 'Объектінің түрін таңдаңыз',
      'Tab Property House': 'Үй',
      'Tab Property Flat': 'Пәтер',
      'Tab Property Input 2': 'Сақтандыру мерзімі',
      'Tab 6 Months': '6 ай',
      'Tab 7 Months': '7 ай',
      'Tab 8 Months': '8 ай',
      'Tab 9 Months': '9 ай',
      'Tab 10 Months': '10 ай',
      'Tab 11 Months': '11 ай',
      'Tab 12 Months': '12 ай',
      'Tab Health': 'Аумақты және сақтандыру мерзімін таңдаңыз',
      'Tab Health Input 1': 'Аумақты таңдаңыз',
      'Tab RK': 'ҚР',
      'Tab CIS': 'ТМД',
      'Tab World': 'Бүкіл әлем',
      'Tab Travel': 'Сақтандыру мерзімі мен баратын еліңізді таңдаңыз',
      'Tab Travel Country': 'Баратын ел',
      'Tab Travel Choose': 'Елді таңдаңыз',
      'Tab Travel All': 'Барлығы',
      'Tab Travel Schengen': 'Шенген',
      'Tab Program': 'Бағдарлама',
      'Tab Program Standard': 'Стандарт',
      'Tab Program Premium': 'Премиум',
      'Tab Program Education': 'Оқыту',
      'Tab Program Sport': 'Спорт',
      'Tab Program Multi-Trip': 'Көп мәрте сапарлау',
      'Tab CASCO': 'Бағдарламаны таңдаңыз',
      'Tab CASCO Sum': 'Сақтандыру сомасы',
      'Tab description': 'Деректер автоматты түрде толтырылады',
      'Tab button': 'Есептеу',
    },
  },
  ru: {
    translation: {
      'Tab CCLI': 'Введите номер телефона и ИИН владельца',
      'Tab CCLI Input 1': 'Гос.номер',
      'Tab CCLI Input 1 Placeholder': 'A000AAA или 000AAA00',
      'Tab CCLI Input 2': 'ИИН',
      'Tab Property': 'Выберите тип объекта и срок страхования',
      'Tab Property Input 1': 'Выберите тип объекта',
      'Tab Property House': 'Дом',
      'Tab Property Flat': 'Квартира',
      'Tab Property Input 2': 'Срок страхования',
      'Tab 6 Months': '6 месяцев',
      'Tab 7 Months': '7 месяцев',
      'Tab 8 Months': '8 месяцев',
      'Tab 9 Months': '9 месяцев',
      'Tab 10 Months': '10 месяцев',
      'Tab 11 Months': '11 месяцев',
      'Tab 12 Months': '12 месяцев',
      'Tab Health': 'Выберите территорию и срок страхования',
      'Tab Health Input 1': 'Территория',
      'Tab RK': 'РК',
      'Tab CIS': 'СНГ',
      'Tab World': 'Весь мир',
      'Tab Travel': 'Выберите период страхования и страну выезда',
      'Tab Travel Country': 'Страна выезда',
      'Tab Travel Choose': 'Выбрать страны',
      'Tab Travel All': 'Весь мир',
      'Tab Travel Schengen': 'Шенген',
      'Tab Program': 'Программа',
      'Tab Program Standard': 'Стандарт',
      'Tab Program Premium': 'Премиум',
      'Tab Program Education': 'Обучение',
      'Tab Program Sport': 'Спорт',
      'Tab Program Multi-Trip': 'Многократные поездки',
      'Tab CASCO': 'Выберите программу',
      'Tab CASCO Sum': 'Страховая сумма',
      'Tab description': 'Данные заполнятся автоматически',
      'Tab button': 'Рассчитать',
    },
  },
};

export default tabsResources;
